<template>
  <div>
    <div class="card mb-3" style="background: #777777; color: #FFFFFF">
      <div class="card-body d-flex align-items-center">
        <div style="font-size: 1.3em;">{{ objects.length | commas }} records found.</div>
        <div class="ml-auto">
          <div class="btn btn-sm btn-light m-1" @click="resetQuery">RESET</div>
        </div>
      </div>
    </div>
    <div>
      <div class="mb-3" v-for="object in objects" :key="object.id">
        <single-organization-in-list v-bind:object-data="object"/>
      </div>
    </div>
  </div>
</template>

<script>
import MedicalAlleyStartsMixin from './MedicalAlleyStartsMixin'
import SingleOrganizationInList from './SingleOrganizationInList'
export default {
  name: 'medical_alley_starts_organization_list_container',
  mixins: [MedicalAlleyStartsMixin],
  components: {SingleOrganizationInList}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/medicalAlleyStarts/OrganizationListContainer.vue